import { PageContainer } from "../../../../components/pageContainer/PageContainer";
import { ReactElement } from "react";
import { useNavigate } from "react-router";
import { NavigationBar } from "../../../../components/navigation/NavigationBar";
import { BUSINESS_INTEGRATION_SETTINGS } from "../../../../constants/routes";
import { SharedIntegrationConfirmContent } from "./SharedIntegrationConfirmContent";

export const IntegrationConfirmFreeAgent = (): ReactElement => {
  const navigate = useNavigate();
  const oAuth2Url = `${
    import.meta.env.VITE_FREE_AGENT_URL
  }/approve_app?client_id=${
    import.meta.env.VITE_FREE_AGENT_CLIENT_ID
  }&redirect_uri=${
    import.meta.env.VITE_URL
  }/business/settings/integrations&response_type=code&state=FreeAgent`;

  return (
    <>
      <NavigationBar
        title={"FreeAgent"}
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => navigate(BUSINESS_INTEGRATION_SETTINGS)}
      />
      <PageContainer>
        <SharedIntegrationConfirmContent
          integrationType={"freeagent"}
          oAuth2Url={oAuth2Url}
        />
      </PageContainer>
    </>
  );
};
